<glxy-page [isLoading]="loading$$ | async">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'PAYOUT_DETAILS_PAGE.BACK_BUTTON_TEXT' | translate"
        [useHistory]="true"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title *ngIf="payout$ | async as payout">
      {{ 'PAYOUT_DETAILS_PAGE.PAGE_TITLE' | translate: { payoutDate: payout.arrivalDate | glxyDate } }}
      <smb-invoicing-payout-status-badge
        class="status-badge"
        [status]="payout.status"
        [failureMessage]="payout.failureMessage"
      ></smb-invoicing-payout-status-badge>
    </glxy-page-title>
  </glxy-page-toolbar>

  <glxy-page-wrapper *ngIf="payoutDetailFields$ | async as payoutFields" [widthPreset]="'wide'">
    <mat-card appearance="outlined" class="card">
      <mat-card-header>
        <mat-card-title>
          {{ 'PAYOUT_DETAILS_PAGE.PAYOUT_DETAILS_CARD_TITLE' | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-grid-list [cols]="10" rowHeight="32px">
          <ng-container *ngFor="let field of payoutFields">
            <mat-grid-tile colspan="2" class="field-tile title">
              <span>{{ field.translationKey | translate }}</span>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" class="field-tile">
              <span [matTooltip]="field.tooltip | translate" [class]="field.class">
                {{ field.value | translate }}
              </span>
            </mat-grid-tile>
          </ng-container>
        </mat-grid-list>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" class="card">
      <mat-card-header>
        <mat-card-title>
          {{ 'PAYOUT_DETAILS_PAGE.PAYMENT_RECORDS_CARD_TITLE' | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <!-- Payment table display component -->
        <ng-content></ng-content>
      </mat-card-content>
    </mat-card>
  </glxy-page-wrapper>
</glxy-page>
